import React from "react";

import ServiceCard from "../../components/cards/serviceCard/ServiceCard";
import { ServicesStyles } from "./ServicesStyles";
import { useTheme } from "../../providers/ThemeContext";
import { useI18n } from "../../languages/providers/I18nProvider";
import { servicesKeys, serviceCardAlts } from "./ServicesContent";
import HeaderSection from "../../components/common/HeaderSection";
import { breadcrumbSchema } from "../../config/seoConfig";
import SEO from "../../components/common/SEO";
import { useLangPath } from "../../hooks/useLangPath";

const ServicesPage = () => {
  const { t, lang } = useI18n();
  const { theme } = useTheme();

  const s = ServicesStyles(theme);
  const lp = useLangPath();

  const translatedCards = servicesKeys.cards.map((c) => ({
    ...c,
    title: t(c.title),
    desc: t(c.desc),
    to: lp(`/services/${c.slug}`),
  }));

  return (
    <>
      <SEO
        title={t("seo:servicesOverview:title")}
        description={t("seo:servicesOverview:description")}
        lang={lang}
        schema={[
          breadcrumbSchema(lang, [
            { name: t("nav:home"), path: "" },
            { name: t("nav:services"), path: "/services" },
          ]),
        ]}
      />
      <main style={s.root}>
        <section style={s.hero}>
          <HeaderSection
            title={t(servicesKeys.hero.title)}
            subtitle={t(servicesKeys.hero.subtitle)}
          />
        </section>

        <section style={s.container}>
          <div className="sc-grid">
            {translatedCards.map((c) => (
              <ServiceCard
                key={c.to}
                title={c.title}
                desc={c.desc}
                img={c.img}
                fit={c.fit}
                alt={serviceCardAlts[c.slug] ?? c.title}
                to={c.to}
                ctaLabel={t("common:learnMore")}
                headingTag="h2"
              />
            ))}
          </div>
        </section>
      </main>
    </>
  );
};

export default ServicesPage;
